ceregoLayoutApp.controller('staticCtrl', ['$scope', '$route', 'UserManager', ($scope, $route, UserManager) ->
  _.assignIn $scope,
    routes: Packs.iKnowRoutes
    learnMore:
      visible: !bowser.msie

  UserManager.loadUser().then (currentUser) ->
    $scope.currentUser = currentUser
])
